import { FunctionComponent } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import { BuySharedFAQQuestion } from './BuySharedFAQQuestion';
import { frequentlyAskedQuestions as frequentlyAskedQuestionsTitle } from '../buyMessages';

import { BuySharedFAQ_buyPage } from './__generated__/BuySharedFAQ_buyPage.graphql';

import styles from './BuySharedFAQ.scss';

type Props = {
    buyPage: BuySharedFAQ_buyPage;
};

const BuySharedFAQComponent: FunctionComponent<Props> = ({ buyPage }) => {
    const questions = buyPage?.questionsAnswers || [];
    const header = buyPage?.meta?.header;

    if (questions.length) {
        return (
            <div className={styles.wrapper}>
                <div className={styles.header} data-tn="faq-header">
                    {frequentlyAskedQuestionsTitle(header)}
                </div>
                <ul>
                    {questions.map((question, index) => (
                        <BuySharedFAQQuestion key={index} question={question} />
                    ))}
                </ul>
            </div>
        );
    }

    return null;
};

export const BuySharedFAQ = createFragmentContainer(BuySharedFAQComponent, {
    buyPage: graphql`
        fragment BuySharedFAQ_buyPage on ItemSearchQueryConnection {
            meta {
                header
            }
            questionsAnswers {
                ...BuySharedFAQQuestion_question
            }
        }
    `,
});
